<template>
    <v-dialog-old class="dialog" ref="dialog" id="treeDialog">
            <div class="tree">
                <span>{{name}}</span>
                <ul class="tree-list">
                    <node-tree v-for="node in children" :node="node" :key="node.id"/>
                </ul>
            </div>

    </v-dialog-old>
</template>

<script>
    import NodeTree from './NodeTree';
    export default {
        name: "TreeDialog",
        components: {
            NodeTree
        },
        props: {
            children: { type: Array, required: true },
            name: {type: String, required: true}
        },
        data() {
            return {};
        },

        methods: {
            open: function () {
                this.$refs.dialog.show();
            },
        },
    }
</script>

<style lang="scss">
 #treeDialog {
     width: 800px;
 }
</style>
